var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowleftsimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77295 4.41583L5.48325 7.70553L8.77295 10.9952L7.75522 12.0058L3.45497 7.70553L7.75522 3.40527L8.77295 4.41583Z",
    fill: "#03154D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleftsimple);
export default __webpack_public_path__ + "static/media/arrowleftsimple.28af0ee98c643b2f279c2f19ef4d93c2.svg";
export { ForwardRef as ReactComponent };